import { render, staticRenderFns } from "./completed-booking.vue?vue&type=template&id=1596e809"
import script from "./completed-booking.vue?vue&type=script&lang=js"
export * from "./completed-booking.vue?vue&type=script&lang=js"
import style0 from "./completed-booking.vue?vue&type=style&index=0&id=1596e809&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports